import { render, staticRenderFns } from "./SingleContentLayout.vue?vue&type=template&id=49e62778&scoped=true&"
import script from "./SingleContentLayout.vue?vue&type=script&lang=js&"
export * from "./SingleContentLayout.vue?vue&type=script&lang=js&"
import style0 from "./SingleContentLayout.vue?vue&type=style&index=0&id=49e62778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e62778",
  null
  
)

export default component.exports